import { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import useAppStore from '../stores/useAppStore';
import useAuthStore from '../stores/useAuthStore';

export default function MainLayout() {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const navigate = useNavigate();

    const { logout: appLogout } = useAppStore();
    const { logout: authLogout, operadorLogado } = useAuthStore();
    // Operador (04/08/2026, perfil de chão de fábrica): sem menu lateral, só a
    // tela de Produção — pedido do usuário pra não distrair o operador com
    // telas de gestão que não são dele.
    const isOperador = operadorLogado?.perfil === 'operador';

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 1024) {
                setSidebarOpen(false);
            }
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleLogout = () => {
        authLogout();
        navigate('/login');
    };

    return (
        <div className="min-h-screen text-anthracite-200 relative overflow-hidden">
            {!isOperador && <Sidebar isOpen={sidebarOpen} />}

            <div className={`transition-[padding-left] duration-300 ease-out ${isOperador ? 'pl-0' : (sidebarOpen ? 'pl-[272px]' : 'pl-[84px]')} w-full min-h-screen flex flex-col relative z-10`}>
                <Header
                    onToggleSidebar={() => setSidebarOpen(!sidebarOpen)}
                    onLogout={handleLogout}
                    // Nome sempre visível no topbar (13/08/2026, pedido do usuário) — antes
                    // só aparecia aqui pro operador (sem sidebar); pra quem tem sidebar, o
                    // nome ficava só no rodapé dela, que some quando ela é recolhida.
                    nomeUsuario={operadorLogado?.nome}
                />

                <main className="flex-1 p-5 lg:p-6 xl:p-8 animate-fade-in">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
